import React, { createContext, useState, useEffect } from 'react'
import {
  listWorkspacesByClientId,
  listWorkspaceSubcategories,
  listFilesByClient
} from '../services/workspaces'
import { listClientsByParent, getClientDataById } from '../services/clients'
import { listClientDocuments } from '../services/documents'
import _ from 'lodash'
import { authContext } from './AuthContext'
import { useContext } from 'react'
import { refreshToken } from '../services/tokens'
import { apiUrl } from '../config/api'

export const misDocumentosContext = createContext({})

const MisDocumentosProvider = ({ children }) => {
  const { auth, replaceToken } = useContext(authContext)

  const [id, setId] = useState(-1)
  const [data, setData] = useState({
    id: -1,
    name: '',
    license: '',
    type: '',
    workspaces: [],
    companies: []
  })
  const [workspaces, setWorkspaces] = useState({})
  const [selectionChain, setSelectionChain] = useState([])
  const [currentViewerDoc, setCurrentViewerDoc] = useState({})

  const initContext = async () => {
    if (id === -1) return

    let clientData = await getClientDataById(id)

    const newData = {
      id: clientData.id,
      name: clientData.name,
      license: clientData.license,
      type: clientData.type,
      workspaces: [],
      companies: []
    }

    let workspaces = await listWorkspacesByClientId(id)
    await Promise.all(
      workspaces.map(async (workspace) => {
        workspace.subcategories = await listWorkspaceSubcategories(
          workspace.workspace_id
        )
      })
    )

    newData.workspaces = JSON.parse(JSON.stringify(workspaces))

    await getClientFiles(id, newData.workspaces)
    if (auth.user.userType === 'client_admin') {
      await getDocumentsadmin(id, newData.workspaces)
    } else {
      await getDocuments(id, newData.workspaces)
    }
    //repeat call for each company
    const companies = await listClientsByParent(id)
    await Promise.all(
      companies.map(async (c) => {
        c.workspaces = JSON.parse(JSON.stringify(workspaces))
        await getClientFiles(c.id, c.workspaces)
        if (auth.user.userType === 'client_admin') {
          await getDocumentsadmin(c.id, c.workspaces)
        } else {
          await getDocuments(c.id, c.workspaces)
        }
      })
    )
    newData.companies = companies

    setWorkspaces(workspaces)
    setData(newData)
  }

  const getDocumentsadmin = async (clientId, clientWorkspaces) => {
    let documents = await listClientDocuments(
      clientId,
      auth.type === 'blp' ? '1' : '0'
    )

    documents.forEach((d) => {
      let ws = _.find(clientWorkspaces, (w) => {
        return w.name_en === d.category_en && w.name_es === d.category_es
      })
      if (ws) {
        let wsSubcategories = ws.subcategories
        let dSubcategory = _.find(wsSubcategories, (s) => {
          return (
            s.subcategory_en === d.subcategory_en &&
            s.subcategory_es === d.subcategory_es
          )
        })
        if (!dSubcategory) return

        if (d.file_id === null) {
          //document directly in subcategory
          if (!dSubcategory.docs) dSubcategory.docs = []
          dSubcategory.docs.push(d)
        } else {
          //document inside specific file
          let dFile = _.find(dSubcategory.files, (f) => {
            return f.id === d.file_id
          })
          if (dFile) {
            if (!dFile.docs) dFile.docs = []
            dFile.docs.push(d)
          }
        }
      }
    })
  }

  const getDocuments = async (clientId, clientWorkspaces) => {
    let url = apiUrl('GetUserDocuments')
    let params = { clientId }

    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: { Authorization: `Bearer ${auth.token}` }
    })

    if (res.status === 401) {
      try {
        const token = await refreshToken(auth.token)
        if (!token) throw new Error('No token returned')
        replaceToken(token)
        window.location.reload(false)
      } catch (error) {
        console.error('Error refreshing token', error)
        window.localStorage.clear()
        window.location.href = '/SignIn'
      }
      return
    }

    const documents = await res.json()

    documents.forEach((d) => {
      try {
        const wsSubcategories = _.find(
          clientWorkspaces,
          (w) => w.name_en === d.category_en && w.name_es === d.category_es
        ).subcategories
        const dSubcategory = _.find(
          wsSubcategories,
          (s) =>
            s.subcategory_en === d.subcategory_en &&
            s.subcategory_es === d.subcategory_es
        )

        if (d.file_id === null) {
          if (!dSubcategory.docs) dSubcategory.docs = []
          dSubcategory.docs.push(d)
        } else {
          const dFile = _.find(dSubcategory.files, (f) => f.id === d.file_id)
          if (dFile) {
            if (!dFile.docs) dFile.docs = []
            dFile.docs.push(d)
          }
        }
      } catch (error2) {}
    })
  }

  const getClientFiles = async (clientId, clientWorkspaces) => {
    let files = await listFilesByClient(clientId)
    files.forEach((f) => {
      let ws = _.find(clientWorkspaces, (w) => {
        return w.workspace_id === f.category_id
      })

      if (!ws || !ws.subcategories) return
      let fSubcategory = []
      fSubcategory = _.find(ws.subcategories, (s) => {
        return s.id === f.subcategory_id
      })

      if (!fSubcategory) return
      if (!fSubcategory.files) fSubcategory.files = []
      fSubcategory.files.push(f)
    })
  }

  const refreshDeletedDoc = async (docId) => {
    _.forEach(data.workspaces, (w) => {
      _.forEach(w.subcategories, (s) => {
        _.forEach(s.files, (f) => {
          let idx = _.findIndex(f.docs, (d) => d.id === docId)
          if (idx > -1) {
            _.remove(f.docs, (d) => d.id === docId)
            return
          }
        })

        let idx = _.findIndex(s.docs, (d) => d.id === docId)
        if (idx > -1) {
          _.remove(s.docs, (d) => d.id === docId)
          return
        }
      })
    })

    _.forEach(data.companies, (c) => {
      _.forEach(c.workspaces, (w) => {
        _.forEach(w.subcategories, (s) => {
          _.forEach(s.files, (f) => {
            let idx = _.findIndex(f.docs, (d) => d.id === docId)
            if (idx > -1) {
              _.remove(f.docs, (d) => d.id === docId)
              return
            }
          })

          let idx = _.findIndex(s.docs, (d) => d.id === docId)
          if (idx > -1) {
            _.remove(s.docs, (d) => d.id === docId)
            return
          }
        })
      })
    })
  }

  const refreshUpdatedDoc = async (doc) => {
    _.forEach(data.workspaces, (w) => {
      _.forEach(w.subcategories, (s) => {
        _.forEach(s.files, (f) => {
          let idx = _.findIndex(f.docs, (d) => d.id === doc.id)
          if (idx > -1) {
            f.docs.splice(idx, 1, doc)
            return
          }
        })

        let idx = _.findIndex(s.docs, (d) => d.id === doc.id)
        if (idx > -1) {
          s.docs.splice(idx, 1, doc)
          return
        }
      })
    })

    _.forEach(data.companies, (c) => {
      _.forEach(c.workspaces, (w) => {
        _.forEach(w.subcategories, (s) => {
          _.forEach(s.files, (f) => {
            let idx = _.findIndex(f.docs, (d) => d.id === doc.id)
            if (idx > -1) {
              f.docs.splice(idx, 1, doc)
              return
            }
          })

          let idx = _.findIndex(s.docs, (d) => d.id === doc.id)
          if (idx > -1) {
            s.docs.splice(idx, 1, doc)
            return
          }
        })
      })
    })
  }

  const refreshAddedDoc = async () => {
    initContext()
  }

  useEffect(() => {
    initContext()
  }, [id])

  return (
    <misDocumentosContext.Provider
      value={{
        id,
        setId,
        data,
        setData,
        workspaces,
        selectionChain,
        setSelectionChain,
        currentViewerDoc,
        setCurrentViewerDoc,
        refreshDeletedDoc,
        refreshUpdatedDoc,
        refreshAddedDoc
      }}
    >
      {children}
    </misDocumentosContext.Provider>
  )
}

export default MisDocumentosProvider
